export default "__VITE_ASSET__ad6a9874__"